/* ============================================================================
   SDOM TLV — Redesign behavior layer  ·  asset: sdom-redesign.js
   Loaded deferred at end of <head> in theme.liquid.
   Keep this minimal: Focal already handles cart drawer, predictive search,
   and mobile menu. We only ADD what the design needs on top.

   v1 scope: turn the announcement bar into a seamless horizontal marquee.
   (Free-shipping progress bar + size-required toast are added in the
    cart / product phases.)
   ========================================================================= */
(function () {
  'use strict';

  /* --- Announcement bar → marquee -----------------------------------------
     Focal renders one or more .announcement-bar__message blocks and rotates
     them. The design wants a single continuous scrolling line. We take the
     first message's text and rebuild it as a duplicated marquee track so the
     loop is seamless (track translates 0 → -50%).
  ------------------------------------------------------------------------- */
  function buildMarquee() {
    var bar = document.querySelector('.announcement-bar');
    if (!bar || bar.dataset.sdomMarquee === 'done') return;

    var msg = bar.querySelector('.announcement-bar__message');
    if (!msg) return;

    var text = (msg.textContent || '').trim();
    if (!text) return;

    // Avoid double-processing and skip if a merchant set up "learn more" content.
    if (bar.querySelector('.announcement-bar__content')) return;

    bar.dataset.sdomMarquee = 'done';

    var marquee = document.createElement('div');
    marquee.className = 'sdom-marquee';

    var track = document.createElement('div');
    track.className = 'sdom-marquee__track';

    // Two identical halves → translateX(-50%) loops seamlessly.
    for (var half = 0; half < 2; half++) {
      var span = document.createElement('span');
      span.setAttribute('aria-hidden', half === 1 ? 'true' : 'false');
      span.textContent = text;
      track.appendChild(span);
    }

    marquee.appendChild(track);

    var list = bar.querySelector('.announcement-bar__list');
    if (list) {
      list.innerHTML = '';
      list.appendChild(marquee);
    } else {
      msg.parentNode.replaceChild(marquee, msg);
    }
  }

  /* PDP: swap the legacy emoji trust block for the clean SVG trust row.
     No-op if it was already replaced (e.g. via the Customizer). */
  function sdomTrustRow() {
    var divs = document.querySelectorAll('div[dir="ltr"]');
    for (var i = 0; i < divs.length; i++) {
      var d = divs[i];
      if (d.dataset.sdomTrust) continue;
      if (/Doorstep delivery/i.test(d.textContent)) {
        d.dataset.sdomTrust = 'done';
        d.innerHTML =
          '<div class="sdom-trust">' +
            '<div class="sdom-trust__row"><svg viewBox="0 0 24 24" aria-hidden="true" stroke-linecap="round" stroke-linejoin="round"><path d="M1 4h13v11H1z"/><path d="M14 8h4l3 3v4h-7z"/><circle cx="5.5" cy="18" r="2"/><circle cx="17.5" cy="18" r="2"/></svg><span>Free shipping over 349.00 ₪</span></div>' +
            '<div class="sdom-trust__row"><svg viewBox="0 0 24 24" aria-hidden="true" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l8 3v6c0 5-3.4 8.5-8 11-4.6-2.5-8-6-8-11V5z"/></svg><span>Secure checkout · all major cards</span></div>' +
            '<div class="sdom-trust__row"><svg viewBox="0 0 24 24" aria-hidden="true" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-2.6-6.4"/><path d="M21 3v4h-4"/></svg><span>14-day easy returns</span></div>' +
          '</div>';
        break;
      }
    }
  }

  function init() { buildMarquee(); sdomTrustRow(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when the announcement section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector) {
      if (e.target.querySelector('.announcement-bar')) buildMarquee();
      sdomTrustRow();
    }
  });
})();
